<div class="profile-container" *ngIf="company">
  <div class="header">
    <h4>company profile</h4>
    <button mat-button *ngIf="highestRole.weight >= 1000" (click)="editCompany()" class="edit_button">
      Edit Company
    </button>
  </div>
  <div *ngIf="company && company.banner" class="banner">
    <img class="bg" [src]="SERVER_URL + 'images/company_' + company.id +  '/' + company.banner.fileName">
    <img *ngIf="company.logo"
         [src]="encodeURI(SERVER_URL + 'images/company_' + company.id +  '/' + company.logo.fileName)" class="logo">
  </div>
  <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start stretch" style="margin-bottom: 20px">
    <div class="block" fxFlex="30">
      <div class="title">information</div>
      <div class="item">
        <div class="icon">
          <mat-icon>phone</mat-icon>
        </div>
        <div class="content">
          <div class="name">contact number</div>
          <div class="value">{{company.phoneNumber ? company.phoneNumber : '-'}}</div>
        </div>
      </div>
      <div class="item">
        <div class="icon">
          <mat-icon>email</mat-icon>
        </div>
        <div class="content">
          <div class="name">email</div>
          <div class="value">{{company.email ? company.email : '-'}}</div>
        </div>
      </div>
      <div class="item">
        <div class="icon">
          <mat-icon>http</mat-icon>
        </div>
        <div class="content">
          <div class="name">website</div>
          <div class="value">{{company.website ? company.website : '-'}}</div>
        </div>
      </div>
    </div>
    <div class="block" fxFlex="70">
      <div class="title">about us</div>
      <p>{{company.notes ? company.notes : 'Not added yet.'}}</p>
    </div>
  </div>
  <div class="block" *ngIf="projects" style="margin-bottom: 20px">
    <div class="title">property sales</div>
    <div fxLayout="row" fxLayoutAlign="space-around center">
      <div class="stat">
        <div class="value">{{projects.length}}</div>
        <div class="name">total projects</div>
      </div>
      <div class="stat">
        <div class="value">{{projects.length}}</div>
        <div class="name">approved projects</div>
      </div>
      <div class="stat">
        <div class="value">257</div>
        <div class="name">sold</div>
      </div>
      <div class="stat">
        <div class="value">428</div>
        <div class="name">Available</div>
      </div>
      <div class="stat">
        <div class="value">16</div>
        <div class="name">reserved</div>
      </div>
    </div>
  </div>
  <div class="block" style="margin-bottom: 20px" *ngIf="personnel">
    <div class="title">team</div>
    <mat-grid-list cols="4" rowHeight="200px" gutterSize="20" style="width: 100%">
      <mat-grid-tile *ngFor="let p of personnel" style="cursor: pointer" [colspan]="1" [rowspan]="1">
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="color: #dedede">
          <img src="{{SERVER_URL}}images{{p.headerUrl}}" *ngIf="p.headerUrl"
               style="width: 100px; height: 100px; border-radius: 50px; object-fit: cover">
          <div *ngIf="!p.headerUrl"
               style="width: 100px; height: 100px; border-radius: 50px; background: #ddd; display: flex; justify-content: center; align-items: center">
            <mat-icon style="color: #fff; font-size: 50px; width: 50px; height: 50px">person</mat-icon>
          </div>
          <div style="font-size: 14px; color: #dedede; ">{{p.firstName}} {{p.lastName}}</div>
          <div>
            <div style="font-size: 12px">{{p.email}}</div>
          </div>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
  <div class="block">
    <div class="title">projects</div>
    <mat-grid-list cols="4" rowHeight="304px" gutterSize="20" style="width: 100%">
      <mat-grid-tile *ngFor="let project of projects" style="cursor: pointer" routerLink="/projects/{{project.id}}"
                     [colspan]="1" [rowspan]="1">
        <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="8px">
          <ng-container *ngIf="project.images && project.images.length > 0">
            <img style="width: 100%; height: 200px; object-fit: cover"
                 [src]="SERVER_URL +'images/' + project.projectCode + '/images/' + project.images[0].fileName"
                 *ngIf="project.images[0].fileName">
          </ng-container>
          <ng-container *ngIf="!project.images || project.images.length === 0">
            <img style="width: 100%; height: 100%; object-fit: cover" src="./assets/images/default-project-logo.jpg">
          </ng-container>
          <div style=" font-size: 14px; color: #dedede">{{project.name}}</div>
          <div style=" font-size: 12px; color: #dedede">{{project.addressLine2}}<br>
            {{project.area}} <br> {{project.state}} {{project.postCode}}</div>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </div>

</div>
